// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Xp-z","imageAndVideoCount":"Yp-z","imageAndVideoContainer":"Zp-z","viewAllReviews":"_p-z"};